import React, { useState } from "react";
import { TextField, MenuItem, Chip, Box, Button, Checkbox, FormControlLabel, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Close, Search } from '@mui/icons-material';

const searchFields = [
    { label: "Device IMEI", value: "deviceIMEI", type: "text" },
    { label: "Relay Support", value: "relaySupport", type: "boolean" },
    { label: "DALI Bus PS", value: "daliBusPsSupport", type: "boolean" },
    { label: "ALS Support", value: "alsSupport", type: "text" },
    { label: "Tilt Support", value: "tiltSupport", type: "text" },
    { label: "Temp Support", value: "tempSupport", type: "text" },
    { label: "PM Support", value: "pmSupport", type: "text" },
    { label: "RF Support", value: "rfSupport", type: "text" },
    { label: "Cell Support", value: "cellSupport", type: "text" },
    { label: "Ext Flash Support", value: "extFlashSupport", type: "text" },
    { label: "Ext EEPROM Support", value: "extEepromSupport", type: "text" },
];

const SearchFilter = ({ filters, onFilterChange }) => {
    const [selectedField, setSelectedField] = useState("");
    const [searchValue, setSearchValue] = useState("");

    const handleAddFilter = () => {
        if (selectedField) {
            const newFilters = [...filters, { field: selectedField, value: searchValue }];
            setSelectedField("");
            setSearchValue("");
            onFilterChange(newFilters);
        }
    };

    const handleRemoveFilter = (field) => {
        const updatedFilters = filters.filter((filter) => filter.field !== field);
        onFilterChange(updatedFilters);
    };

    const handleCopyIMEIs = () => {
        const imeiFilter = filters.find((filter) => filter.field === "deviceIMEI");
        if (imeiFilter) {
            navigator.clipboard.writeText(imeiFilter.value);
        }
    };

    const availableFields = searchFields.filter((field) => !filters.some((filter) => filter.field === field.value));

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" gap={2} alignItems="center">
                <TextField
                    select
                    label="Select Field"
                    value={selectedField}
                    onChange={(e) => setSelectedField(e.target.value)}
                    size="small"
                    sx={{ minWidth: 200 }}
                >
                    {availableFields.map((field) => (
                        <MenuItem key={field.value} value={field.value}>
                            {field.label}
                        </MenuItem>
                    ))}
                </TextField>

                {selectedField && searchFields.find((f) => f.value === selectedField)?.type === "boolean" ? (
                    <>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={searchValue === "true"}
                                    onChange={() => setSearchValue("true")}
                                />
                            }
                            label="Enabled"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={searchValue === "false"}
                                    onChange={() => setSearchValue("false")}
                                />
                            }
                            label="Disabled"
                        />
                    </>
                ) : (
                    <TextField
                        label="Search Value"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                    />
                )}

                <Button variant="contained" color="primary" onClick={handleAddFilter}>
                    <Search />
                </Button>
            </Box>
            <Box display="flex" flexWrap="wrap" gap={1}>
                {filters.map((filter) => {
                    if (filter.field === "deviceIMEI") {
                        const imeiList = filter.value.split(",");
                        return (
                            <Chip
                                key={filter.field}
                                label={imeiList.length > 3 ? `IMEIs (${imeiList.length})` : `IMEI: ${filter.value}`}
                                color="primary"
                                onDelete={() => handleRemoveFilter(filter.field)}
                                deleteIcon={
                                    imeiList.length > 3 ? (
                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                            <Tooltip title="Copy IMEIs">
                                                <IconButton onClick={() => handleCopyIMEIs(filter.value)} size="small">
                                                    <ContentCopyIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <IconButton onClick={() => handleRemoveFilter(filter.field)} size="small">
                                                <Close fontSize="small" />
                                            </IconButton>
                                        </div>
                                    ) : <Close fontSize="small" />
                                }
                            />
                        );
                    }
                    return (
                        <Chip
                            key={filter.field}
                            label={`${searchFields.find((f) => f.value === filter.field)?.label}: ${filter.value}`}
                            onDelete={() => handleRemoveFilter(filter.field)}
                            color="primary"
                        />
                    );
                })}
            </Box>
        </Box>
    );
};

export default SearchFilter;
